import { render, staticRenderFns } from "./ProlongationsList.vue?vue&type=template&id=44061396&scoped=true&"
import script from "./ProlongationsList.vue?vue&type=script&lang=js&"
export * from "./ProlongationsList.vue?vue&type=script&lang=js&"
import style0 from "./ProlongationsList.vue?vue&type=style&index=0&id=44061396&lang=scss&scoped=true&"
import style1 from "./ProlongationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44061396",
  null
  
)

export default component.exports